var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSmsFeatureAblaufgrafikMobilStep2Rgb = function SvgSmsFeatureAblaufgrafikMobilStep2Rgb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 300 180",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "schrift"
  }, /*#__PURE__*/React.createElement("g", {
    id: "schrift-2",
    "data-name": "schrift"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M73.2,16.2c0-3.8,2.4-6.1,5.3-6.1a4.4,4.4,0,0,1,3.4,1.5l-1.2,1.3a3,3,0,0,0-2.2-1c-1.9,0-3.3,1.6-3.3,4.2s1.3,4.3,3.2,4.3A4.3,4.3,0,0,0,81,19.3l1.1,1.3a4.6,4.6,0,0,1-3.7,1.6C75.5,22.2,73.2,20.1,73.2,16.2Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9,16.1c0-3.8,2.2-6,5.1-6s5.1,2.3,5.1,6-2.2,6.1-5.1,6.1S82.9,19.9,82.9,16.1Zm8.2,0c0-2.7-1.2-4.2-3.1-4.2s-3.1,1.5-3.1,4.2,1.2,4.3,3.1,4.3S91.1,18.8,91.1,16.1Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5,10.3h3.1c3.6,0,5.8,2,5.8,5.8S102.2,22,98.7,22H95.5Zm3.1,10c2.3,0,3.7-1.3,3.7-4.2S100.9,12,98.6,12h-1v8.3Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.8,10.3h7v1.8h-5v3h4.3v1.8h-4.3v3.4h5.1v1.8h-7.2V10.3Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.8,10.3h2.5l3.8,11.8h-2.2l-1.8-6.3c-.4-1.2-.7-2.5-1-3.8H127c-.4,1.3-.7,2.7-1,3.8l-1.8,6.3H122Zm-1.5,6.9h5.5v1.7h-5.5Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.4,10.3h2.1l3.6,6.6,1.2,2.5h.1c-.1-1.1-.3-2.7-.3-3.9V10.3h2V22.1h-2.2l-3.6-6.6L135.2,13H135a26.9,26.9,0,0,1,.3,4v5.1h-1.9Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.1,10.3h7.1v1.8h-5v3.4h4.2v1.7h-4.2v4.9h-2.1Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.4,16.1c0-3.8,2.2-6,5.1-6s5.2,2.3,5.2,6-2.2,6.1-5.2,6.1S153.4,19.9,153.4,16.1Zm8.2,0c0-2.7-1.1-4.2-3.1-4.2s-3,1.5-3,4.2,1.1,4.3,3,4.3S161.6,18.8,161.6,16.1Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.1,10.3h4c2.4,0,4.3.9,4.3,3.5s-1.9,3.7-4.3,3.7h-2v4.6h-2Zm3.8,5.5c1.7,0,2.5-.6,2.5-2s-.9-1.8-2.5-1.8h-1.6v3.8Zm-.2,1.1,1.5-1.3,3.7,6.4h-2.3Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.7,10.3h3.1c3.5,0,5.7,2,5.7,5.8s-2.2,5.9-5.6,5.9h-3.2Zm3.1,10c2.3,0,3.7-1.3,3.7-4.2s-1.4-4.1-3.7-4.1h-.9v8.3Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.9,10.3H195v1.8h-5v3h4.2v1.8H190v3.4h5.1v1.8h-7.3V10.3Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.5,10.3h4c2.4,0,4.3.9,4.3,3.5s-1.9,3.7-4.3,3.7h-1.9v4.6h-2.1Zm3.7,5.5c1.7,0,2.5-.6,2.5-2s-.9-1.8-2.5-1.8h-1.6v3.8Zm-.1,1.1,1.5-1.3,3.7,6.4H204Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.1,10.3h2.2l3.6,6.6,1.1,2.5h.2a24.7,24.7,0,0,1-.3-3.9V10.3h1.9V22.1h-2.1l-3.6-6.6L209.9,13h-.1c.1,1.3.3,2.7.3,4v5.1h-2Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_5",
    "data-name": "Ebene 5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.9,173.9H198v-4.5c0-14.2-9.9-25.8-22.1-25.8h-.5c-2.6-16-14.6-28.1-29-28.1a24.7,24.7,0,0,0-8.6,1.5c-6.7-15.4-20.4-25.9-36.2-25.9s-29,10.2-35.8,25.2a24.8,24.8,0,0,0-6.1-.7c-14.5,0-26.6,12.3-29.1,28.4a22,22,0,0,0-3.6-.4c-12.2,0-22.1,11.5-22.1,25.8v4.5Z",
    style: {
      fill: "var(--ca-primary-color-lightest, #96e3fa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1,173.9H265.5v-3.7a22.1,22.1,0,0,0-22.1-22.1h-.5A29.6,29.6,0,0,0,213.8,124a27.1,27.1,0,0,0-8.6,1.3,40.6,40.6,0,0,0-72.1-.6,30.8,30.8,0,0,0-6.1-.6,29.5,29.5,0,0,0-29.1,24.4l-3.6-.3a22.1,22.1,0,0,0-22.1,22.1v3.6Z",
    style: {
      fill: "var(--ca-primary-color-lighter, #5fcced)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.5,173.9H296.1v-2.8c0-8.9-7.9-16-17.6-16h-.4c-2-9.9-11.6-17.5-23.1-17.5a24.8,24.8,0,0,0-6.8.9c-5.3-9.6-16.2-16.1-28.8-16.1s-23.1,6.3-28.5,15.6a26.1,26.1,0,0,0-4.8-.5c-11.6,0-21.2,7.6-23.1,17.7l-2.9-.2c-9.7,0-17.6,7.2-17.6,16v2.9Z",
    style: {
      fill: "var(--ca-primary-color-lightest, #96e3fa)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152,157.4v-1.8a40.9,40.9,0,0,0,6-.7l.3,1.8A61.8,61.8,0,0,1,152,157.4Zm-5.1-.1c-2-.1-4.1-.3-6.1-.6l.3-1.8a55.4,55.4,0,0,0,6,.6Zm-11-1.6a45,45,0,0,1-6-1.7l.6-1.7a55.4,55.4,0,0,0,5.8,1.7Zm27.2,0-.4-1.8q2.9-.7,5.7-1.8l.6,1.7Zm-37.9-3.5-5.5-2.8.9-1.6a45.3,45.3,0,0,0,5.4,2.7Zm48.5-.4-.8-1.6a53.9,53.9,0,0,0,5.2-3l.9,1.6A55.4,55.4,0,0,1,173.7,151.8Zm-58.2-5.2a45.4,45.4,0,0,1-4.8-3.9l1.2-1.3a53.2,53.2,0,0,0,4.6,3.7Zm67.7-.8-1.1-1.4a41.9,41.9,0,0,0,4.5-3.9l1.3,1.3A58.5,58.5,0,0,1,183.2,145.8Zm-76.1-6.7c-1.3-1.6-2.6-3.2-3.8-4.9l1.5-1a54.5,54.5,0,0,0,3.7,4.7Zm84.3-1L190,137c1.3-1.5,2.5-3.1,3.7-4.7l1.5,1C194,135,192.7,136.6,191.4,138.1Zm-90.8-8.2a56,56,0,0,1-2.7-5.5l1.6-.7a52.8,52.8,0,0,0,2.7,5.3Zm97.3-.9-1.6-.9a33.6,33.6,0,0,0,2.6-5.4l1.7.8C199.8,125.3,198.9,127.2,197.9,129ZM96.1,119.6a56.9,56.9,0,0,1-1.6-5.9l1.8-.4c.4,1.9.9,3.9,1.5,5.8Zm106.3-.9-1.8-.6a37,37,0,0,0,1.6-5.7l1.7.3Q203.3,115.7,202.4,118.7Zm-108.7-10c-.2-2.1-.4-4.1-.4-6.2h1.8a56.5,56.5,0,0,0,.4,5.9Zm111-1-1.8-.2c.2-2,.3-4,.3-5.9v-3H205v3.1C205,103.6,204.9,105.7,204.7,107.7ZM95.2,97.6l-1.8-.2c.2-2,.4-4.1.8-6.1l1.7.3C95.6,93.6,95.4,95.6,95.2,97.6Zm107.5-3.8a56,56,0,0,0-1.2-5.9l1.7-.4a40,40,0,0,1,1.3,6ZM97,86.8l-1.7-.4a40.6,40.6,0,0,1,1.9-5.9l1.6.7A52.2,52.2,0,0,0,97,86.8Zm103-3.6a37.6,37.6,0,0,0-2.3-5.5l1.6-.8q1.3,2.8,2.4,5.7Zm-99.2-6.5-1.6-.8a46.8,46.8,0,0,1,3-5.4l1.6,1A44,44,0,0,0,100.8,76.7Zm94.5-3.3a52.5,52.5,0,0,0-3.3-4.9l1.4-1.1c1.2,1.6,2.4,3.3,3.5,5.1Zm-88.7-5.9-1.4-1.1a61,61,0,0,1,4.1-4.6l1.3,1.2A42.8,42.8,0,0,0,106.6,67.5Zm82.2-2.7a56.6,56.6,0,0,0-4.3-4.2l1.2-1.3a57.7,57.7,0,0,1,4.4,4.2Zm-74.6-5-1.1-1.4a57.4,57.4,0,0,1,5-3.6l1,1.5A40,40,0,0,0,114.2,59.8Zm66.4-2.2a52.9,52.9,0,0,0-5-3.2l.9-1.6c1.7,1,3.5,2.1,5.2,3.3Zm-57.3-3.8-.8-1.6,5.6-2.5.7,1.7A53.8,53.8,0,0,0,123.3,53.8Zm47.9-1.6a54.2,54.2,0,0,0-5.6-2.2l.6-1.7,5.7,2.2Zm-37.8-2.3-.5-1.8c2-.5,4-1,6-1.3l.4,1.7A56.3,56.3,0,0,0,133.4,49.9Zm27.5-1.1a40.4,40.4,0,0,0-5.9-1l.2-1.8c2,.2,4.1.6,6.1,1Zm-16.8-1-.2-1.8c1.7-.1,3.4-.3,5.1-.3h1.1v1.8H149Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.2,167.5l-3.4-.2v-1.8l3.4.2h2.5v1.8Zm7.8-.5-.2-1.8c1.9-.2,3.9-.6,5.9-1l.3,1.8Zm-16.3-.3c-2-.2-4-.6-6-1l.4-1.8L141,165Zm27.2-2-.5-1.7c1.9-.6,3.8-1.2,5.7-2l.6,1.7Zm-38.1-.2-5.8-2,.6-1.7a54.4,54.4,0,0,0,5.7,1.9Zm48.6-3.9-.8-1.6,5.2-2.9.9,1.5A55.4,55.4,0,0,1,178.4,160.6Zm-59.1-.1a56.1,56.1,0,0,1-5.4-2.9l.9-1.5c1.7,1,3.5,1.9,5.3,2.8Zm68.6-5.7-1-1.5a41.4,41.4,0,0,0,4.6-3.7l1.2,1.4C191.2,152.3,189.6,153.6,187.9,154.8Zm-78.2,0c-1.7-1.2-3.3-2.5-4.9-3.8l1.2-1.4a55.8,55.8,0,0,0,4.7,3.8Zm86.7-7.3-1.3-1.3a58.2,58.2,0,0,0,4-4.5l1.4,1.2Zm-95.2,0a58.5,58.5,0,0,1-4-4.7l1.4-1.1a41.9,41.9,0,0,0,3.9,4.5Zm102.3-8.7-1.5-1c1.2-1.7,2.2-3.4,3.2-5.1l1.6.9A56.9,56.9,0,0,1,203.5,138.8Zm-109.3-.1a56.4,56.4,0,0,1-3.1-5.3l1.5-.8c1,1.7,2,3.5,3.1,5.1Zm114.9-9.6-1.7-.8c.9-1.8,1.6-3.7,2.3-5.5l1.7.6C210.7,125.3,209.9,127.2,209.1,129.1Zm-120.2-.2a57.7,57.7,0,0,1-2.2-5.8l1.7-.6a53.7,53.7,0,0,0,2.1,5.6Zm124-10.4-1.8-.5a54.3,54.3,0,0,0,1.3-5.8l1.8.3C213.8,114.5,213.4,116.5,212.9,118.5Zm-127.6-.3a57.9,57.9,0,0,1-1.2-6l1.8-.3c.3,2,.7,4,1.1,5.9Zm129.5-10.7-1.8-.2q.3-3,.3-6h1.8C215.1,103.4,215,105.4,214.8,107.5Zm-131.3-.3c-.1-1.8-.2-3.6-.2-5.4V101h1.8v.7c0,1.7.1,3.5.2,5.2ZM213.1,96.8c-.1-1.9-.4-3.9-.7-5.9l1.8-.3c.3,2,.5,4.1.7,6.1ZM85.3,96.1H83.5c.2-2.1.4-4.1.7-6.1l1.8.3A56,56,0,0,0,85.3,96.1Zm126.1-10c-.5-1.9-1.1-3.9-1.7-5.7l1.7-.6c.6,1.9,1.2,3.9,1.7,5.9ZM87,85.4l-1.7-.5c.5-2,1-3.9,1.7-5.9l1.7.6C88.1,81.5,87.5,83.4,87,85.4Zm120.8-9.6c-.8-1.8-1.7-3.6-2.6-5.4l1.5-.8a47.3,47.3,0,0,1,2.8,5.5ZM90.5,75l-1.7-.7,2.7-5.5,1.6.8C92.2,71.4,91.3,73.2,90.5,75Zm112.1-8.8-3.5-4.8,1.4-1.1c1.2,1.6,2.5,3.2,3.6,4.9ZM95.7,65.4l-1.5-1a56,56,0,0,1,3.6-4.9l1.4,1.1A53.4,53.4,0,0,0,95.7,65.4Zm100.1-7.7c-1.3-1.4-2.8-2.8-4.3-4.2l1.2-1.3a59.3,59.3,0,0,1,4.4,4.3Zm-93.4-.8-1.3-1.2q2.3-2.2,4.5-4.2l1.2,1.3Zm85.3-6.5c-1.6-1.2-3.3-2.3-4.9-3.3l.9-1.6,5.1,3.5Zm-77-.6-1.1-1.5a56.9,56.9,0,0,1,5.2-3.3l.9,1.5A53.9,53.9,0,0,0,110.7,49.8Zm67.8-5.2L173,42.1l.7-1.6a56.2,56.2,0,0,1,5.6,2.5ZM120,44.3l-.7-1.7,5.6-2.4.7,1.7A55.5,55.5,0,0,0,120,44.3Zm48.4-3.8c-1.9-.6-3.9-1.2-5.8-1.6l.4-1.7a56.6,56.6,0,0,1,5.9,1.5Zm-38.2-.1-.5-1.7q3-.9,6-1.5l.4,1.8Zm10.7-2.2-.2-1.8a60,60,0,0,1,6.1-.6v1.8Q143.9,37.8,140.9,38.2Zm16.8-.1a56.1,56.1,0,0,0-5.9-.6V35.7c2,.1,4.1.3,6.1.6Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.3,
    cy: 37,
    r: 25.5,
    style: {
      fill: "none",
      stroke: "var(--ca-primary-color-base, #009dd4)",
      strokeMiterlimit: 10,
      strokeOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M178.9,170.3H120.5a10,10,0,0,1-9.9-9.9V45.6a10,10,0,0,1,9.9-9.9h58.4a10,10,0,0,1,10,9.9V160.4A10,10,0,0,1,178.9,170.3Z",
    style: {
      fill: "#fff",
      stroke: "var(--ca-primary-color-base, #009dd4)",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.7,166.3H120.9a5.8,5.8,0,0,1-5.8-5.8V45.5a5.8,5.8,0,0,1,5.8-5.8h57.8a5.8,5.8,0,0,1,5.8,5.8v115A5.8,5.8,0,0,1,178.7,166.3Z",
    style: {
      fill: "var(--ca-primary-color-lightest, #96e3fa)",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.8,90.9H132.4a3.8,3.8,0,0,0-3.8,3.8v37l7.2-11.6h34.9a3.8,3.8,0,0,0,3.8-3.8V94.7A3.7,3.7,0,0,0,170.8,90.9Zm-27.4,19.2a5.4,5.4,0,0,1-.9,1.2,4.6,4.6,0,0,1-1.5.9,7.1,7.1,0,0,1-2.1.3,7,7,0,0,1-2.5-.5,6.4,6.4,0,0,1-2.2-1.4l1.6-2a5.1,5.1,0,0,0,1.6.9,3.2,3.2,0,0,0,1.6.4,1.8,1.8,0,0,0,1.3-.4,1.1,1.1,0,0,0,.5-.9.7.7,0,0,0-.1-.5.8.8,0,0,0-.4-.4l-.6-.3-.7-.2-1.7-.7-1-.5-.8-.7a2.1,2.1,0,0,1-.6-1,2.3,2.3,0,0,1-.2-1.2,2.6,2.6,0,0,1,.4-1.5,4.2,4.2,0,0,1,2.4-2.1,4.8,4.8,0,0,1,1.8-.3,5,5,0,0,1,2.1.5,6.2,6.2,0,0,1,1.9,1.2l-1.5,1.8-1.2-.7a3.2,3.2,0,0,0-1.4-.3,2.8,2.8,0,0,0-1.3.3.8.8,0,0,0-.4.8,4.3,4.3,0,0,0,.1.5l.4.4.7.2.7.3,1.6.7a3.8,3.8,0,0,1,1.9,1.3,4.8,4.8,0,0,1,.5,3.9Zm14.4,2.2h-2.7v-5.7c0-.4.1-.8.1-1.1s.1-.8.1-1.2.1-.7.1-1h-.1l-1,3-1.8,4.8h-1.6l-1.8-4.8-1.1-3h-.1c0,.3.1.6.1,1s.1.8.1,1.2.1.7.1,1.1v5.7h-2.3V99.6H149l2.1,5.7.3,1.1c.1.4.3.8.4,1.2h.1a8.3,8.3,0,0,0,.4-1.2,3.6,3.6,0,0,1,.4-1.1l2-5.7h3.1v12.7Zm11.3-2.2a5.4,5.4,0,0,1-.9,1.2,4.6,4.6,0,0,1-1.5.9,7.1,7.1,0,0,1-2.1.3,7,7,0,0,1-2.5-.5,6.4,6.4,0,0,1-2.2-1.4l1.7-2a3.8,3.8,0,0,0,1.5.9,3.2,3.2,0,0,0,1.6.4,1.8,1.8,0,0,0,1.3-.4,1.1,1.1,0,0,0,.5-.9.7.7,0,0,0-.1-.5l-.4-.4-.6-.3-.7-.2-1.7-.7-1-.5-.8-.7a2.1,2.1,0,0,1-.6-1,2.3,2.3,0,0,1-.2-1.2,2.6,2.6,0,0,1,.4-1.5,4.2,4.2,0,0,1,2.4-2.1,4.8,4.8,0,0,1,1.8-.3,5,5,0,0,1,2.1.5,5.2,5.2,0,0,1,1.9,1.2l-1.4,1.9a3.7,3.7,0,0,0-1.2-.7,3.2,3.2,0,0,0-1.4-.3,2.8,2.8,0,0,0-1.3.3c-.3.1-.4.4-.4.8a.7.7,0,0,0,.1.5c.1.1.2.3.4.4l.7.2.7.3,1.6.7a3.8,3.8,0,0,1,1.9,1.3,3.1,3.1,0,0,1,.7,2.2A2.2,2.2,0,0,1,169.1,110.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "127.8 134.5 99.6 130.2 103.5 135.1 101.6 140.9 106.1 139 106.3 140.5 107.3 146 127.8 134.5",
    style: {
      fill: "#2db7e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.7 134.6 103.5 135.2 101.5 140.9 106.1 139 105.9 138.1 127.7 134.6",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "215.4 117.5 201.4 128 205.2 128.4 206.9 131.7 208 128.9 208.8 129.5 211.6 131.4 215.4 117.5",
    style: {
      fill: "#2db7e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.4 117.5 205.2 128.4 206.9 131.8 208 128.9 207.5 128.6 215.4 117.5",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "205 67.9 207.9 89.8 210.6 85.9 215.1 86.2 212.8 83.2 213.8 82.7 217.6 80.8 205 67.9",
    style: {
      fill: "#2db7e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205 68 210.6 86 215.2 86.2 212.8 83.2 212.2 83.5 205 68",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "88 77.4 105.5 60.7 100.2 60.8 97.4 56.4 96.3 60.5 95.2 59.9 90.9 57.6 88 77.4",
    style: {
      fill: "#2db7e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88 77.3 100.2 60.7 97.4 56.4 96.3 60.5 97 60.8 88 77.3",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "86.6 120.4 91 97.4 86.9 100.4 82.2 98.6 83.6 102.4 82.4 102.6 77.8 103.2 86.6 120.4",
    style: {
      fill: "#2db7e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.5 120.3 86.8 100.3 82.1 98.6 83.6 102.4 84.3 102.3 86.5 120.3",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSmsFeatureAblaufgrafikMobilStep2Rgb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sms-feature-ablaufgrafik-mobil-step2-rgb.388d395b8ebeabed1f7f1eb71bd5c51f.svg";